import { render, staticRenderFns } from "./CardEventDate.vue?vue&type=template&id=2775bd27&"
import script from "./CardEventDate.vue?vue&type=script&lang=js&"
export * from "./CardEventDate.vue?vue&type=script&lang=js&"
import style0 from "./CardEventDate.vue?vue&type=style&index=0&id=2775bd27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports